import { BRAND } from "constants/brand";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useOrder from "hooks/useOrder";
import { readApiError } from "utils/apiError";
import { fieldOf } from "utils/formField";

const EditOrder = (props) => {
    const form = useRef();
    const nodeRef = useRef();
    const { loading, editOrder } = useOrder();

    const submitHandler = async (e) => {
        e.preventDefault();
        const orderData = new FormData();

        orderData.append("name", fieldOf(form.current, "name").value);
        orderData.append("phone", fieldOf(form.current, "phone").value);
        orderData.append("address", fieldOf(form.current, "address").value);
        orderData.append("total", fieldOf(form.current, "total").value);
        orderData.append("shipping", fieldOf(form.current, "shipping").value);

        try {
            const response = await editOrder(props.order.id, orderData);
            // `response.message` was the fallback here, which on a failure is
            // axios's English "Request failed with status code 400". The API's
            // own Arabic sentence lives on `response.response.data.message`,
            // which is what readApiError reads.
            const failure = readApiError(response, "حدث خطأ غير متوقع");

            if (failure) {
                props.showMessage("error", "هناك خطأ", failure);
                return;
            }

            props.showMessage("success", "تم التعديل", "تمت تعديل الطلب بنجاح");
            props.close();
        } catch (err) {
            props.showMessage("error", "هناك خطأ", readApiError(err, "حدث خطأ غير متوقع"));
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>تعديل طلب</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="1">
                                <Form.Label>
                                    الاسم<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="name"
                                    defaultValue={props.order?.name}
                                    type="text"
                                    placeholder=""
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="2">
                                <Form.Label>
                                    رقم الهاتف<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="phone"
                                    defaultValue={props.order?.phone}
                                    type="text"
                                    placeholder=""
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="3">
                                <Form.Label>
                                    العنوان<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="address"
                                    defaultValue={props.order?.address}
                                    type="text"
                                    placeholder=""
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="4">
                                <Form.Label>
                                    قيمه الطلب (₪) <span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="total"
                                    defaultValue={props.order?.subtotal}
                                    type="number"
                                    min={0}
                                    placeholder=""
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="4">
                                <Form.Label>
                                    الشحن (₪) <span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="shipping"
                                    defaultValue={props.order?.shipping}
                                    type="number"
                                    min={0}
                                    placeholder=""
                                    required
                                />
                            </Form.Group>
                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    إرسال
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default EditOrder;
